import { useState, useEffect } from "react";

export function useCollapsibleState(key: string, defaultOpen: boolean = true): [boolean, (open: boolean) => void] {
  const storageKey = `collapsible-${key}`;
  
  const [isOpen, setIsOpen] = useState(() => {
    if (typeof window === "undefined") return defaultOpen;
    const stored = localStorage.getItem(storageKey);
    return stored !== null ? stored === "true" : defaultOpen;
  });

  useEffect(() => {
    localStorage.setItem(storageKey, String(isOpen));
  }, [isOpen, storageKey]);

  return [isOpen, setIsOpen];
}
